import jQuery from 'jquery'
window.$ = window.jQuery = jQuery


// WEBPACK FOOTER //
// ./src/plugins/jquery.js